import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class InspectionService {
  public async addInspection(inspectionModel: any) {
    let jsonBody = JSON.stringify(inspectionModel);
    try {
      let response = await fetch(`${BASE_URL}/inspections/add`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: jsonBody,
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
  public async editInspection(inspectionModel: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/inspections/${inspectionModel._id}`,
        {
          method: "POST",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(inspectionModel),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
  public async deleteInspection(inspectionModel: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/inspections/${inspectionModel._id}`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }

  public async deleteAllSelectedInspections(selectedList: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/inspections/delete/multiple`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(selectedList),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
  public async getInspectionsByCompanyId(inspectionId: String) {
    try {
      let response = await fetch(
        `${BASE_URL}/inspections/companies/${inspectionId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
}
